export default "__VITE_ASSET__060e6795__"